// @ts-ignore
 
import request from "src/lib/axios";

/** C 端获取 SKU 详情 用户进入 SKU 详情页，携带 SKU ID 获取 SKU 详情 GET /api/v1/app/skus/${param0} */
export async function AppSkuControllerDetailV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppSkuControllerDetailV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputClientProductSkuDto>(
    `/api/v1/app/skus/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}
